<template>
  <Section
    class="template-section"
    title="丰富的PPT模板持续更新"
    desc="选择PPT模板，AI一键排版，全面提高生产力"
  >
    <div class="template-section__tag-list">
      <div class="track">
        <div class="group">
          <span v-for="text in textList" :key="text + '1'">{{ text }}</span>
        </div>
        <div class="group">
          <span v-for="text in textList" :key="text + '2'">{{ text }}</span>
        </div>
        <div class="group">
          <span v-for="text in textList" :key="text + '3'">{{ text }}</span>
        </div>
      </div>
    </div>
    <div class="template-section__template-grid">
      <Img
        class="template-section__img"
        :src="item"
        v-for="(item, index) in templateImages"
        :key="index"
      />
    </div>
    <ArrowBtn
      class="template-section__btn"
      text="免费试用"
      variant="black-common"
      @click="$emit('trail')"
    />
  </Section>
</template>

<script setup lang="ts">
import Section from '@/design/widgets/landing-section/cn-template.vue';
import { getFeUrl } from '@/utils/url';
import Img from '@rendora/design/components/img/Img.vue';
import ArrowBtn from '~/design/components/buttons/arrow-btn.vue';

const textList = [
  '教育行业',
  '政府政务',
  '金融理财',
  '零售快消',
  '工业制造',
  '软件服务',
  '文传广电',
  '法律服务',
  '医疗健康',
  '文旅产业',
  '家电家居',
  '能源环保',
  '汽车产业',
  '企业培训',
];

const templateImages = [
  getFeUrl('/youyan-platform/ai-ppt/ppt-templates/1-1.png?x-oss-process=image/format,webp'),
  getFeUrl('/youyan-platform/ai-ppt/ppt-templates/1-2.png?x-oss-process=image/format,webp'),
  getFeUrl('/youyan-platform/ai-ppt/ppt-templates/1-3.png?x-oss-process=image/format,webp'),
  getFeUrl('/youyan-platform/ai-ppt/ppt-templates/1-4.png?x-oss-process=image/format,webp'),

  getFeUrl('/youyan-platform/ai-ppt/ppt-templates/2-1.png?x-oss-process=image/format,webp'),
  getFeUrl('/youyan-platform/ai-ppt/ppt-templates/2-2.png?x-oss-process=image/format,webp'),
  getFeUrl('/youyan-platform/ai-ppt/ppt-templates/2-3.png?x-oss-process=image/format,webp'),
  getFeUrl('/youyan-platform/ai-ppt/ppt-templates/2-4.png?x-oss-process=image/format,webp'),
];
</script>

<style lang="scss" scoped>
.template-section {
  padding-top: 224px;
  :deep(.section-header) {
    margin-bottom: 40px;
  }
}

.template-section__btn {
  margin-top: 40px;
}
.template-section__template-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
}

.template-section__img {
  aspect-ratio: 276 / 313;
  border-radius: 8px;
  border: 1px solid var(--x-back-5);
  width: 100%;
}
.template-section__tag-list {
  position: relative;
  color: var(--x-text-7);
  font-size: var(--x-text-14-size);
  line-height: 20px;
  overflow: hidden;
  width: calc(100% + 48px);
  max-width: calc(1440px + 48px);
  margin-bottom: 40px;
  .track {
    display: flex;
    width: max-content;
    animation: scroll 24s linear infinite;
  }
  .group {
    margin-right: 0px;
    span {
      margin-right: 32px;
    }
  }

  &::before {
    content: '';
    position: absolute;
    left: 0px;
    top: 0;
    width: 24px;
    height: 100%;
    background: linear-gradient(to right, var(--x-back-1), rgba(255, 255, 255, 0));
    pointer-events: none;
    z-index: 2;
  }
  &::after {
    content: '';
    position: absolute;
    right: 0px;
    top: 0;
    width: 24px;
    height: 100%;
    background: linear-gradient(to left, var(--x-back-1), rgba(255, 255, 255, 0));
    pointer-events: none;
  }

  @media (max-width: 1440px) {
    width: 100%;
  }
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>
